export default "__VITE_ASSET__CRxfPDjh__"